import type { DefaultTheme } from 'styled-components'
import styled, { css } from 'styled-components'

function getPromo(color: string, background: string) {
  return css`
    background-color: ${background};
    color: ${color};
    width: auto;
  `
}

interface Props {
  prime: boolean
  theme: DefaultTheme
}

function getTemplate({ prime, theme }: Props) {
  if (prime === true) {
    return getPromo(theme.colors.grey8, theme.colors.prime1)
  }

  const bgColor = theme.colors.brand1

  return css`
    background-color: ${bgColor};
    color: ${theme.colors.grey8};
    text-transform: lowercase;
  `
}

export const DiscountTagBase = styled.div<Props>`
  ${props => getTemplate(props)};
  cursor: pointer;
  display: inline-block;
  font-weight: 700;
  line-height: 20px;
  font-size: 14px;

  text-align: start;
  min-width: 65px;
  padding-block: 4px;
  padding-inline: 20px 6px;
  border-start-end-radius: 8px;
  border-end-end-radius: 8px;
  border-end-start-radius: 0;
  border-start-start-radius: 0;
  margin-block-start: 0;
  margin-block-end: 6px;
`

export const PrimeDiscountText = styled.div`
  display: flex;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.colors.grey8};
    margin-inline-end: 6px;
  }
`
